// Fontawesome
import { config } from '@fortawesome/fontawesome-svg-core';
import { faCog } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Link from 'found/Link';
import PropTypes from 'prop-types';
import React from 'react';
import {
  DropdownItem, DropdownMenu, DropdownToggle, UncontrolledButtonDropdown,
} from 'reactstrap';

// Fontawesome CSS needs to be loaded?
config.autoAddCss = true;

/**
 * Description
 * @param {any} props
 * @returns {React.ReactComponentElement} - ContactActions component
 */
function ContactActions(props) {
  const { uuid, options } = props;

  if (options === undefined || options.length === 0) {
    return (
      null
    );
  }

  return (
    <UncontrolledButtonDropdown>
      <DropdownToggle caret color="darken">
        <FontAwesomeIcon icon={faCog} />
      </DropdownToggle>
      <DropdownMenu end>
        {
          options.map((opt) => {
            const { name, path } = opt;
            const pathToOption = `/users/${uuid}/${path}`; // Example of path to an option? for example path to remove a specific contact.
            return (
              <DropdownItem key={pathToOption}>
                <Link to={pathToOption}>
                  {name}
                </Link>
              </DropdownItem>
            );
          })
        }
      </DropdownMenu>
    </UncontrolledButtonDropdown>
  );
}

ContactActions.propTypes = {
  uuid: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      path: PropTypes.string,
    }),
  ),
};

ContactActions.defaultProps = {
  options: [],
};

export default ContactActions;
